import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Logo } from "./Logo";
import { NAV_IDS } from "./Header";
import { scrollToId } from "./SmoothScroll";
import { Reveal } from "./Motion";
import { CONTACT_VAT, CONTACT_ADDRESS } from "./Contact";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative bg-[var(--ink)] border-t border-[var(--line)] pt-16 pb-8 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="flex items-center gap-3">
              <Logo className="w-12 h-12 shrink-0" />
              <span className="leading-none">
                <span className="block text-lg tracking-[0.04em] text-[var(--bone)]" style={{ fontFamily: '"Fraunces", serif', fontWeight: 600 }}>MF Logistics</span>
                <span className="mono block text-[10px] text-[rgba(246,241,232,0.7)] mt-1 uppercase">Consulting Group</span>
              </span>
            </span>
            <p className="mt-5 text-[rgba(246,241,232,0.75)] max-w-sm">{t.footer.tagline}</p>
          </div>
          <nav className="lg:col-span-4 grid grid-cols-2 gap-3">
            {NAV_IDS.map((id) => (
              <button key={id} data-testid={`footer-nav-${id}`} onClick={() => scrollToId(id)} className="text-left text-[rgba(246,241,232,0.85)] hover:text-[var(--amber-2)] transition-colors w-fit">{t.nav[id]}</button>
            ))}
          </nav>
          <div className="lg:col-span-3 lg:text-right">
            <button data-testid="footer-back-to-top" onClick={() => scrollToId("top")} className="group inline-flex items-center gap-2 mono text-[12px] uppercase border border-[var(--line)] rounded-full px-4 py-2 hover:border-[var(--amber-2)] hover:text-[var(--amber-2)] transition-colors">
              {t.footer.top}<ArrowUp className="w-3.5 h-3.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </div>
        </div>
        <Reveal y={80}>
          <p aria-hidden="true" className="display text-[11vw] lg:text-[9vw] leading-none mt-14 text-[var(--bone)]/90 select-none">
            MF<span className="serif text-[var(--amber)] normal-case">—</span>LCG
          </p>
        </Reveal>
        <div className="mt-8 pt-6 border-t border-[var(--line)] flex flex-col md:flex-row gap-3 justify-between mono text-[11px] uppercase text-[rgba(246,241,232,0.7)]">
          <span>© {new Date().getFullYear()} MF Logistics Consulting Group · {t.contact.vatLabel} {CONTACT_VAT} · {CONTACT_ADDRESS}</span>
          <span className="opacity-60">♪ "Minimal Ambient Corporate" — BFCMUSIC</span>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-[var(--amber-2)] transition-colors">{t.footer.admin}</Link>
        </div>
      </div>
    </footer>
  );
};
